import metamorphClient from "./metamorphClient"

export function getSizeChartContentById(brandId: string, categoryId: string) {
  return metamorphClient.get(`/api/v1/_internal/size/meta/${brandId}/${categoryId}`)
}

export function createSizeChartEditor(brand_id: string, category_id: string, author: string, content: any) {
  return metamorphClient.post(`/api/v1/_internal/size/`, {
    brand_id: brand_id,
    category_id: category_id,
    author: author,
    version: '1',
    content: content,
  })
}

export function saveSizeChartEditor(
  id: string,
  brand_id: string,
  category_id: string,
  content: any,
) {
  return metamorphClient.put(`/api/v1/_internal/size/${id}`, {
    brand_id: brand_id,
    category_id: category_id,
    content: content,
  })
}

export function getAbout() {
  return metamorphClient.get(`/api/v1/about`)
}
